<template>
    <div>
        <b-modal
            id="cancel_booking_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div>{{lbl.history.head_cancel}}</div>
                </div>
                <div class="modal-base-body">

                    <div class="booking-detail-wrapper">


                        <div class="item">{{lblBooking.order_no}} {{bookingImformation.serial}}</div>
                        <div class="item">{{lblBooking.name}} {{bookingImformation.name}}</div>
                        <div class="item">{{lblBooking.member_id}} {{bookingImformation.memberId}}</div>
                        <div class="item">{{lblBooking.gift}} {{bookingImformation.giftName}}</div>
                        <div class="item">{{lblBooking.branch}} {{bookingImformation.branceShow}}</div>

                    </div>
                </div>
                <div class="modal-base-footer btn-redeem-wrapper">
                    <button class="btn btn-cancel" @click="clickCloseConfirmRedeem()">{{lblConfirmRedeem.cancel2}}</button>
                    <button class="btn ml-2 btn-confirm" @click="clickConfirmRedeem()">{{lblConfirmRedeem.confirm2}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    name: 'CancelbookingModal',
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object
    },
    data: function () {
        return {
            headline: '',
            message: '',
            bookingImformation: '',

            lblConfirmRedeem: {},
            lblDate: {},
            lblBooking: {},
            id: '',
        };
    },
    mounted: function () {
        console.log("confirmredeem");
        console.log(this.lbl.cancel_booking);
        this.lblBooking = this.lbl.gift_detail.confirm_redeem;
        this.lblDate = this.lbl.date;
        this.lblConfirmRedeem = this.lbl.confirm_redeem;
        this.busModal.$on('showConfirmRedeemModal', this.initialConfirmModal);
        this.busModal.$on('hideConfirmRedeemModal', this.closeConfirmModal);
    },
    methods: {
        //Event
        clickConfirmRedeem: function () {
            this.$emit('clickCancelBooking', this.id);
            this.closeConfirmModal();
        },
        clickCloseConfirmRedeem: function () {
            this.closeConfirmModal();
        },
        //Function
        initialConfirmModal: function (purchase) {
            console.log(purchase);
            // this.headline = this.lblConfirmRedeem.reward_confirm;
            // this.message = this.lblConfirmRedeem.default1 + " " + this.campaign.pointPerUnit + " " + this.lblConfirmRedeem.default2;
           // var tmpInfo = JSON.parse(purchase.info3);

            var tmpImformation = {
                serial: purchase.serial,
                name: purchase.dataInfo.name,
                memberId: purchase.dataInfo.membercode,
                branch: purchase.dataInfo.counterName,
                dateFormat: purchase.dataInfo.dateFormat,
                timeFrom : purchase.dataInfo.timeFrom,
                timeTo : purchase.dataInfo.timeTo,
                timeFormat: purchase.dataInfo.timeFormat,
                branceShow: purchase.dataInfo.brance,
                bcsName: purchase.dataInfo.bcsName,
                giftName: purchase.dataInfo.giftName,
            }
            console.log('tmpImformation', tmpImformation)
            this.bookingImformation = tmpImformation;
            this.id = purchase;
            this.$bvModal.show('cancel_booking_modal');

        },
        closeConfirmModal: function () {
            this.$bvModal.hide('cancel_booking_modal');
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
}
</script>
<style lang="scss" scoped>
    #headline {
        text-align: center;
        font-weight: bold;
    }

    #message {
        text-align: center;
    }

    #cancel_booking_modal{

        .modal-base-head {
            color: #000000;
            font-weight: bold;
            font-size: 20px;
            text-align: center;
        }

        .booking-detail-wrapper {
            padding-top: 15px;
            padding-bottom: 20px;
            text-align: center;
            .head2 {
                font-size: 15px;
                padding-bottom: 20px;
                text-align: center;
            }
            .item {
                font-size: 12px;
                padding-bottom: 8px;
            }
            .question-mark{
                font-family: 'century';
            }
        }

        .btn-redeem-wrapper {
            text-align: center;
            display: flex;
            flex-wrap: nowrap;

            .btn-cancel {
                width: 50%;
                background-color: white;
                color: black;
                border-color: black;
                border-radius: 0;
                min-height: 50px;
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 2px;
            }

            .btn-confirm {
                width: 50%;
                background-color: black;
                color: white;
                border-color: black;
                border-radius: 0;
                min-height: 50px;
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 2px;
            }
        }
    }
</style>
<style lang="scss">
    #cancel_booking_modal{

        .modal-dialog{
            margin-left: 2rem;
            margin-right: 2rem;
            .modal-content{

                border-radius: 0px;
            }
        }
    }
</style>
